import { MenuOutlined } from '@ant-design/icons'
import { Button, Col, Drawer, Row } from 'antd'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Logo from 'src/assets/images/logo_new.png'

function Header(props) {
  const { handleClickSignIn, handleClickRegister } = props
  const navigate = useNavigate()
  const token = localStorage.getItem('access_token')
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  const handleLogout = () => {
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('access_token')
    navigate(0)
  }

  const clickRegister = () => {
    setIsDrawerOpen(false)
    handleClickRegister()
  }
  const clickSignIn = () => {
    setIsDrawerOpen(false)
    handleClickSignIn()
  }

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen)
  }

  const openMenuMobile = () => {
    setIsDrawerOpen(true)
  }

  const clickToHistories = () => {
    setIsDrawerOpen(false)
    navigate('/histories')
  }

  return (
    <>
      <Row
        gutter={[24, 24]}
        className="flex items-center justify-between mt-8 menu-pc"
      >
        <Col className="order-first"></Col>
        <Col className="order-last">
          {!token && (
            <>
              <Button
                className="btn bg-transparent text-2xl h-[40px] font-[Plus Jakarta Sans] mr-4"
                onClick={clickSignIn}
              >
                Đăng nhập
              </Button>
              <Button
                className="btn bg-transparent text-2xl h-[40px] font-[Plus Jakarta Sans]"
                onClick={clickRegister}
              >
                Đăng ký
              </Button>
            </>
          )}
          {token && (
            <>
              <Button
                className="btn bg-transparent text-2xl h-[40px] font-[Plus Jakarta Sans] mr-4"
                onClick={clickToHistories}
              >
                Lịch sử
              </Button>
              <Button
                className="btn bg-transparent text-2xl h-[40px] font-[Plus Jakarta Sans] mr-4"
                onClick={handleLogout}
              >
                Đăng xuất
              </Button>
            </>
          )}
        </Col>
      </Row>
      <Row gutter={[24, 24]} className="mt-4 menu-mobile hidden ">
        <Col
          lg={{ span: 2, offset: 22 }}
          xs={{ span: 3, offset: 21 }}
          className="order-last"
        >
          <MenuOutlined
            onClick={openMenuMobile}
            className="text-2xl cursor-pointer "
          />
        </Col>
      </Row>
      <Drawer
        title="Menu"
        placement="right"
        onClose={toggleDrawer}
        open={isDrawerOpen}
        className="text-black"
      >
        {!token && (
          <>
            <Button className="text-md w-full mb-4" onClick={clickSignIn}>
              Đăng nhập
            </Button>
            <Button className="text-md w-full" onClick={clickRegister}>
              Đăng ký
            </Button>
          </>
        )}
        {token && (
          <>
            <Button className="text-md w-full mb-2" onClick={clickToHistories}>
              Lịch sử đặt vé
            </Button>
            <Button className="text-md w-full mb-2" onClick={handleLogout}>
              Đăng xuất
            </Button>
          </>
        )}
      </Drawer>
      <Row gutter={[24, 24]} className="flex items-center justify-between">
        <a href="/" className="flex items-center m-auto">
          <img className="w-[220px]" src={Logo} alt="Logo" />
        </a>
      </Row>
    </>
  )
}

export default Header
